const SOUND_URL = '/sounds/notify.ogg';
const COOLDOWN_MS = 3000;

let audio: HTMLAudioElement | null = null;
let lastPlayedAt = 0;

function getAudio(): HTMLAudioElement | null {
  if (typeof Audio === 'undefined') return null;
  if (!audio) {
    audio = new Audio(SOUND_URL);
    audio.preload = 'auto';
    audio.volume = 0.6;
  }
  return audio;
}

export function playNotificationSound(): void {
  const now = Date.now();
  if (now - lastPlayedAt < COOLDOWN_MS) return;
  lastPlayedAt = now;

  const a = getAudio();
  if (!a) return;
  try {
    a.currentTime = 0;
    void a.play().catch(() => {
      /* autoplay blocked until user interacts — acceptable, will work after first interaction */
    });
  } catch {
    /* no-op */
  }
}
